import ArchiveTrackHeading from './ArchiveTrackHeading';

export default ArchiveTrackHeading;
